import { createQuery } from '@tanstack/svelte-query';
import { QUERY_KEY_SHORTLINK } from '../constants';
import { client } from '../lib/client';

const getShortlink = async (shortlinkId) => {
  const response = await client.get(`/api/get-shortlink/${shortlinkId}`);

  if (response.status !== 200) {
    throw new Error('Shortlink does not exist');
  }

  return response.data?.object || null;
};

export const queryShortlink = (shortlinkId) =>
  createQuery({
    queryKey: [QUERY_KEY_SHORTLINK, shortlinkId],
    queryFn: () => getShortlink(shortlinkId),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!shortlinkId,
  });
